module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full"
  }, [_c('div', {
    staticClass: "systemTypeContainer"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("displayerSystemType.displayerTitle")))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t("displayerSystemType.selectSystemType")))]), _vm._v(" "), _c('div', {
    staticClass: "systemTypeBlocContainer"
  }, [_c('router-link', {
    attrs: {
      "to": "/param_meuble"
    }
  }, [_c('SystemTypeItem', {
    attrs: {
      "systemTypeId": 1
    }
  })], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/templates/new?type=2"
    }
  }, [_c('SystemTypeItem', {
    attrs: {
      "systemTypeId": 2
    }
  })], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/templates/new?type=3"
    }
  }, [_c('SystemTypeItem', {
    attrs: {
      "systemTypeId": 3
    }
  })], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/templates/new?type=4"
    }
  }, [_c('SystemTypeItem', {
    attrs: {
      "systemTypeId": 4
    }
  })], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f08e238a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/plano/config/carcass/carcass.vue
// module id = 3394
// module chunks = 0